import { ReactNode } from 'react';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { useNavegate } from 'App/hooks';
import {
  ActionProp,
  ActionsDesktop,
  ErrorScreen,
  HeaderContent,
  HeaderTop,
  IonPageStratus,
} from 'commons/components';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ProductsTransfersEmpty } from '.';

interface TransferListPageProps {
  skeleton: ReactNode;
  isLoading: boolean;
  isEmpty: boolean;
  isError: boolean;
  children: ReactNode;
  onRetry: () => void;
}

function TransferListPage({
  skeleton,
  isLoading,
  isEmpty,
  isError,
  children,
  onRetry,
}: Readonly<TransferListPageProps>) {
  const t = useTranslationCatalog();
  const { goTo } = useNavegate();

  const title = !isEmpty ? t('transfers.list.title') : '';
  const gotoCreate = () => goTo(CATALOG_ROUTES.newTransfer);

  const createTransferAction: ActionProp = {
    icon: PlusCircleIcon,
    children: t('transfers.list.add'),
    appearance: 'default',
    onClick: gotoCreate,
  };

  const desktopActions: ActionProp[] = [
    {
      icon: PlusCircleIcon,
      children: t('transfers.list.add'),
      appearance: 'primary',
      onClick: gotoCreate,
    },
  ];

  return (
    <IonPageStratus
      width="medium"
      headerTop={
        <HeaderTop mainAction={!isEmpty ? createTransferAction : undefined} />
      }
      headerContent={
        <HeaderContent
          title={title}
          actions={!isEmpty && <ActionsDesktop actions={desktopActions} />}
        />
      }
      headerFixed
    >
      {isLoading && skeleton}
      {isError && <ErrorScreen onRetry={onRetry} />}
      {isEmpty && <ProductsTransfersEmpty />}
      {!isLoading && !isError && !isEmpty && children}
    </IonPageStratus>
  );
}

export default TransferListPage;
